import api from "../axios/axiosConfig";

export const getAddress = async (address: string) => {
    try {
        const response = await api.get(`/AddressSearch/${address}`);
        return response.data;
    } catch (error: any) {
        throw error;
    }
};